import e from"./HitsPerPage.vue_vue&type=script&lang.js";import{render as t}from"./HitsPerPage.vue_vue&type=template&id=654e3b4a&lang.js";e.render=t;export default e;
//# sourceMappingURL=HitsPerPage.vue.js.map
